/* ── Carousel arrows ─────────────────────────────────────────── */
document.querySelectorAll('.products__track-wrap').forEach(wrap => {
  const track = wrap.querySelector('.products__track');
  const prev  = wrap.querySelector('.products__arrow--prev');
  const next  = wrap.querySelector('.products__arrow--next');
  if (!track || !prev || !next) return;

  const scrollBy = () => {
    const card = track.querySelector('.book-card');
    return card ? card.offsetWidth + 22 : 300;
  };

  next.addEventListener('click', () => track.scrollBy({ left: scrollBy(), behavior: 'smooth' }));
  prev.addEventListener('click', () => track.scrollBy({ left: -scrollBy(), behavior: 'smooth' }));
});

/* ── Mobile nav hamburger ────────────────────────────────────── */
const hamburger = document.querySelector('.nav__hamburger');
if (hamburger) {
  hamburger.addEventListener('click', () => {
    const left = document.querySelector('.nav__left');
    const right = document.querySelector('.nav__right');
    const open = hamburger.classList.toggle('is-open');
    if (left)  { left.style.display  = open ? 'flex' : ''; }
    if (right) { right.style.display = open ? 'flex' : ''; }
  });
}

/* ── Testimonial dots (static placeholder) ───────────────────── */
document.querySelectorAll('.testimonials__dot').forEach((dot, i, dots) => {
  dot.addEventListener('click', () => {
    dots.forEach(d => d.classList.remove('testimonials__dot--active'));
    dot.classList.add('testimonials__dot--active');
  });
});
